function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ButtonBase from './ButtonBase';
import classNames from 'classnames';
import { SVGIcon } from '@homeaway/react-svg';
import "./ButtonIconBase.css";

var ButtonIcon = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ButtonIcon, _Component);

  function ButtonIcon() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = ButtonIcon.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        svgMarkup = _this$props.svgMarkup,
        svgId = _this$props.svgId,
        circle = _this$props.circle,
        className = _this$props.className,
        noBorder = _this$props.noBorder,
        rest = _objectWithoutProperties(_this$props, ["svgMarkup", "svgId", "circle", "className", "noBorder"]);

    var buttonIconClassName = classNames('btn-icon', 'ButtonIcon', className, {
      'btn-icon-circle': circle,
      'ButtonIcon--no-border': noBorder
    });
    var finalIconMarkup;

    if (svgMarkup) {
      finalIconMarkup = /*#__PURE__*/React.createElement(SVGIcon, {
        useFill: true,
        className: "flex-center",
        markup: svgMarkup
      });
    } else if (svgId) {
      finalIconMarkup = /*#__PURE__*/React.createElement("span", {
        className: "flex-center"
      }, /*#__PURE__*/React.createElement(SVGIcon, {
        useFill: true,
        id: svgId
      }));
    }

    return /*#__PURE__*/React.createElement(ButtonBase, _extends({
      srOnlyLabel: true,
      className: buttonIconClassName
    }, rest), finalIconMarkup, this.props.children);
  };

  return ButtonIcon;
}(Component);

ButtonIcon.propTypes = _extends({}, ButtonBase.propTypes, {
  /** SVG markup from @homeaway/svg-defs module. Please reference directly from lib/defs/ */
  svgMarkup: PropTypes.string,

  /** ID name of SVG from an SVG Definition block, the xlink:href of the SVG you want. Used in the 'use' tag to grab it's definition from the SVG Definitions */
  svgId: PropTypes.string,

  /** Flag to determine if this component should also have className .btn-icon-circle */
  circle: PropTypes.bool,

  /** Flag to remove border from ButtonIcon.  Will append className .ButtonIcon--no-border */
  noBorder: PropTypes.bool
});
export default ButtonIcon;
//# sourceMappingURL=ButtonIconBase.js.map